<script>
import toHTML from 'linkifyjs/html';

export default {
  name: 'CpPostFeedDialog',
  components: {
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    CpTextInput: require('../inputs/text').default,
    CpOpinionsContainer: require('../opinions/opinions-container').default,
    CpAuthForm: require('../auth-form/index').default,
    CpSharePost: require('./share-post').default,
    CpLobbyDialog: require('./lobby').default,
    CpPetitionSign: require('./sign-petition').default,
  },
  props: {
    handleFeedDialog: Function,
    user: Object,
    updateFeed: Function,
    placeholderStatusPost: String,
    publication: Object,
    post: Object,
    modalType: String,
  },
  data() {
    return {
      loading: false,
      postSuccess: false,
      postError: false,
      authData: {},
    };
  },
  created() {
    if (this.post && !this.post.user_id && !this.user) {
      this.postSuccess = true;
      this.authData = {
        type: this.modalType,
        post: this.post.id,
      };
    }
  },
  methods: {
    handleAuthModal(id) {
      this.authData = {
        type: this.modalType,
        post: id,
      };
      this.postSuccess = !this.postSuccess;
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
  },
};
</script>
<template>
    <cp-dialog v-if="modalType == 'status_post'">
        <cp-box>
            <cp-box-content>
                <section class="box-section">
                    <div v-if="postSuccess && !authUser" class="share-container">
                        <h4 v-if="post" class="alert">That information wasn't quite right.  Please try again.</h4>
                        <cp-auth-form style="margin:0 auto" :login-type="modalType" :additional-fields="authData">
                            <template #sign-in-title>Your Post is ready to go on the feed! Sign in to complete</template>
                            <template #registration-title>Your Post is ready to go on the feed! Sign up to complete</template>
                        </cp-auth-form>
                    </div>
                    <template v-else-if="!postSuccess && !postError" class="share-container">
                        <svg
                            @click.prevent="handleFeedDialog()"
                            class="close-svg-icon"
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                            ></path>
                        </svg>
                        <cp-opinions-container
                            :current-user="user"
                            :name="user != null ? user.first_name : ''"
                            :placeholder-status-post="placeholderStatusPost"
                            :reload="updateFeed"
                            :modalFeed="true"
                            @postButtonClicked="handleAuthModal"
                        />
                    </template>
                </section>
            </cp-box-content>
        </cp-box>
    </cp-dialog>
    <div v-else-if="modalType == 'shared_news'">
        <cp-dialog v-if="postSuccess && !authUser">
            <cp-box>
                <cp-box-content>
                    <section class="box-section">
                        <div class="share-container">
                            <h4 v-if="post" class="alert">That information wasn't quite right.  Please try again.</h4>
                            <cp-auth-form style="margin:0 auto" :login-type="modalType" :additional-fields="authData">
                                <template #sign-in-title>Your Post is ready to go on the feed! Sign in to complete</template>
                                <template #registration-title>Your Post is ready to go on the feed! Sign up to complete</template>
                            </cp-auth-form>
                        </div>
                    </section>
                </cp-box-content>
            </cp-box>
        </cp-dialog>
        <cp-share-post
            v-else-if="!postSuccess && !postError"
            :showDialog="true"
            :post="publication"
            :type="'news'"
            :handleDialog="handleFeedDialog"
            :modalFeed="true"
            @postButtonClicked="handleAuthModal"
        />
    </div>
    <div v-else-if="modalType == 'lobby_endorse_s' || modalType == 'lobby_oppose_s' || modalType == 'lobby_endorse_r' || modalType == 'lobby_oppose_r'">
        <cp-dialog v-if="postSuccess && !authUser">
            <cp-box>
                <cp-box-content>
                    <section class="box-section">
                        <div class="share-container">
                            <svg
                                @click.prevent="handleFeedDialog()"
                                class="close-svg-icon"
                                stroke="currentColor"
                                fill="currentColor"
                                stroke-width="0"
                                viewBox="0 0 512 512"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                                ></path>
                            </svg>
                            <h4 v-if="post" class="alert">That information wasn't quite right.  Please try again.</h4>
                            <cp-auth-form style="margin:0 auto" :login-type="modalType" :additional-fields="authData">
                                <template #sign-in-title>Your Lobby is ready to go on the feed! Sign in to complete</template>
                                <template #registration-title>Your Lobby is ready to go on the feed! Sign up to complete</template>
                            </cp-auth-form>
                        </div>
                    </section>
                </cp-box-content>
            </cp-box>
        </cp-dialog>
        <cp-lobby-dialog
            v-else-if="!postSuccess && !postError"
            :showDialog="true"
            :politician="publication"
            :type="modalType == 'lobby_endorse_s' || modalType == 'lobby_endorse_r' ? 'endorse' : 'oppose'"
            :handleDialog="handleFeedDialog"
            :user="user"
            :modalFeed="true"
            @postButtonClicked="handleAuthModal"
        />
    </div>
    <div v-else-if="modalType == 'sign_petition'">
        <cp-dialog v-if="postSuccess && !authUser">
            <cp-box>
                <cp-box-content>
                    <section class="box-section">
                        <div class="share-container">
                            <svg
                                @click.prevent="handleFeedDialog()"
                                class="close-svg-icon"
                                stroke="currentColor"
                                fill="currentColor"
                                stroke-width="0"
                                viewBox="0 0 512 512"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                                ></path>
                            </svg>
                            <cp-auth-form style="margin:0 auto" login-type="return_url" />
                        </div>
                    </section>
                </cp-box-content>
            </cp-box>
        </cp-dialog>
        <div v-else-if="!postSuccess && !postError">
            <cp-petition-sign
                v-if="user"
                :petition_id="publication.id"
                :loggedin="true"
                :user="{
                    first_name: user.first_name,
                    last_name: user.last_name,
                    email: user.email,
                    zip: user.address_zip
                }"
                :handleDialog="handleFeedDialog"
                :modalFeed="true"
                @postButtonClicked="handleAuthModal"
            >
            </cp-petition-sign>
            <cp-petition-sign
                v-else-if="!user"
                :petition_id="publication.id"
                :loggedin="false"
                :user="{
                    first_name:'',
                    last_name:'',
                    email:'',
                    zip: ''
                }"
                :handleDialog="handleFeedDialog"
                :modalFeed="true"
                @postButtonClicked="handleAuthModal"
            >
            </cp-petition-sign>
        </div >
    </div>
  </div>
</template>
<style scoped>
.alert {
  border-radius: 0;
  background: #ffefe8;
  color: #ff4814;
  border: solid 0 #ff4814;
  border-left-width: 3px;
  padding: 8px 35px 8px 14px;
  margin-bottom: 20px;
  text-shadow: 0 1px 0 rgb(255 255 255 / 50%);
  font-family: 'rooney-web', georgia, serif;
  font-weight: 300;
  font-size: 14px;
}
.box-section {
  margin: 2em;
  width: 80ch;
}
.share-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
.share-icon {
  font-size: 3em;
  color: var(--success);
}
.error-icon {
  font-size: 3em;
  color: red;
}
div.icon-wrapper {
  width: 100%;
  height: 100%;
  flex-direction: row;
  align-content: center;
  align-items: center;
  background-image: none !important;
  margin-top: 0px;
}
svg.share-svg-icon {
  height: 1em;
  width: 1em;
}
div.network-text-title {
  font-size: 10px;
  font-weight: 700;
  padding-bottom: 5px;
}
svg.close-svg-icon {
  float: right;
  top: 5px;
  right: 5px;
  position: absolute;
  height: 2.5em;
  width: 2.5em;
  cursor: pointer;
}
div.feed svg {
  color: #555555 !important;
  height: 1.5em !important;
  width: 1.5em !important;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .box-section {
    margin: 1.4em;
    width: 60ch;
  }
}
@media only screen and (max-width: 767px) {
  .box-section {
    margin: 1.4em;
    width: auto;
  }
}
</style>
